import { isDeniedOperation } from './deny.js';
const RESCHEDULE_FIELDS = ['scheduled_at', 'scheduled_at_local'];
const CAMPAIGN_FIELDS = ['name', 'goal', 'starts_on', 'ends_on', 'target_markets', 'languages', 'pillar_ids', 'planned_count', 'role_targets', 'cta', 'landing_url'];
/**
 * Positive allow-list (ADR-030): only these operationIds are reachable with a token. The read
 * operations of the read tools (S290-4) and the plan operations of the plan tools (S290-5); a test fails
 * when an entry matches the deny rules. A campaign's status and a publication's account, variant or text
 * stay out of reach through `permittedFields`.
 */
export const EXTERNAL_OPERATIONS = [
    ...[
        'listProperties',
        'getProperty',
        'getPropertyWritingStyle',
        'getPropertyPostingSettings',
        'listMediaAssets',
        'getMediaAsset',
        'listKnowledgeItems',
        'getKnowledgeItem',
        'listEntryTypes',
        'listEntries',
        'getEntry',
        'listContentPillars',
        'getContentPillar',
        'listCampaigns',
        'getCampaign',
        'listContentItems',
        'getContentItem',
        'listPublications',
        'getPublication',
        'listContentComments',
        'listInboxMessages',
        'getAnalyticsSummary',
        'getWeekOverview',
        'getContentMix',
        'listCheckFindings',
    ].map((operationId) => ({ operationId, scope: 'read' })),
    { operationId: 'createCampaign', scope: 'plan', permittedFields: ['property_id', ...CAMPAIGN_FIELDS], creates: true },
    { operationId: 'updateCampaign', scope: 'plan', permittedFields: CAMPAIGN_FIELDS },
    { operationId: 'createContentItem', scope: 'plan', creates: true },
    { operationId: 'updateContentItem', scope: 'plan' },
    { operationId: 'createContentLocalization', scope: 'plan' },
    { operationId: 'updateContentLocalization', scope: 'plan' },
    { operationId: 'replaceContentVariantMedia', scope: 'plan' },
    { operationId: 'createContentVariant', scope: 'plan' },
    { operationId: 'createPublication', scope: 'plan' },
    { operationId: 'updatePublication', scope: 'plan', permittedFields: RESCHEDULE_FIELDS },
    { operationId: 'updatePublicationGroup', scope: 'plan', permittedFields: RESCHEDULE_FIELDS },
    { operationId: 'addContentComment', scope: 'plan' },
    { operationId: 'requestContentChanges', scope: 'plan' },
    // Scope `media` (ADR-040): upload one file, then attach a finished video to a reel. The release and
    // rights flags are the token owner's statement, audited under their name; title and tags stay in the library.
    { operationId: 'createMediaUpload', scope: 'media' },
    { operationId: 'finalizeMediaUpload', scope: 'media', permittedFields: ['upload_id', 'property_id', 'people_visible', 'social_release', 'season', 'pillar_id', 'entry_ids', 'location'] },
    { operationId: 'getVariantStoryboard', scope: 'read' },
    { operationId: 'createVariantStoryboard', scope: 'media', permittedFields: ['mode', 'uploaded_asset_id', 'rights_confirmed', 'cover'] },
    { operationId: 'replaceStoryboard', scope: 'media', permittedFields: ['mode', 'uploaded_asset_id', 'rights_confirmed', 'cover'] },
];
/** Throws when an entry breaks the hard boundary; used by the policy registry and by tests. */
export function assertAllowedOperation(entry) {
    if (isDeniedOperation(entry.operationId)) {
        throw new Error(`operation ${entry.operationId} is on the external deny-list and cannot be allow-listed`);
    }
}
//# sourceMappingURL=operations.js.map